import { ProductColorOption } from './types';

type VariantLike = {
  sku?: string;
  images?: string[];
  attributes?: { [key: string]: any };
};

const asLabel = (value: unknown, fallback: string): string =>
  typeof value === 'string' && value.trim().length > 0 ? value : fallback;

export const getProductColorOptions = (variants?: VariantLike[]): ProductColorOption[] => {
  const options = new Map<string, ProductColorOption>();

  variants?.forEach((variant) => {
    const color = variant?.attributes?.color;
    const key = color?.key;

    if (typeof key !== 'string' || key.length === 0) return;

    const image = variant?.images?.find((imageUrl) => !!imageUrl);
    const existing = options.get(key);

    if (!existing) {
      options.set(key, {
        key,
        label: asLabel(color?.label, key),
        hexColor:
          typeof variant?.attributes?.customColor === 'string' && variant.attributes.customColor.trim().length > 0
            ? variant.attributes.customColor.trim()
            : undefined,
        imageUrl: image,
        sku: variant?.sku,
      });
      return;
    }

    if (!existing.imageUrl && image) {
      existing.imageUrl = image;
    }
  });

  return [...options.values()];
};
